import React from 'react';
import { Button, Space, Typography, Breadcrumb, Row, Col } from 'antd';
import { 
  ArrowLeftOutlined, 
  PrinterOutlined, 
  EditOutlined,
  HomeOutlined,
  ShoppingOutlined
} from '@ant-design/icons';

const { Title } = Typography;

const OrderActions = ({ orderNumber, onBack, onPrint, onEdit }) => {
  return (
    <div style={{ marginBottom: 24 }}>
      {/* Breadcrumb */}
      <Breadcrumb 
        style={{ marginBottom: 16 }}
        items={[
          {
            href: '/',
            title: <HomeOutlined />,
          },
          {
            href: '/orders',
            title: (
              <Space>
                <ShoppingOutlined />
                <span>Orders</span>
              </Space>
            ),
          },
          {
            title: `Order ${orderNumber}`,
          },
        ]}
      />

      {/* Header Actions */}
      {/* <Row justify="space-between" align="middle">
        <Col>
          <Space align="center">
            <Button 
              icon={<ArrowLeftOutlined />} 
              onClick={onBack}
              type="default"
            >
              Back to Orders
            </Button>
            <Title level={3} style={{ margin: 0 }}>
              Order Details
            </Title>
          </Space>
        </Col>
        <Col>
          <Space>
            
          </Space>
        </Col>
      </Row> */}
    </div>
  );
};

export default OrderActions; 